<scrollable-tabs [tabs]="tabs" (emitSelectedTab)="selectedTab($event)"></scrollable-tabs>
<router-outlet></router-outlet>